import {w3cwebsocket as W3CWebSocket} from "websocket";
import {Ticks} from "../models/SGB";
import Config from "../Config";
const base= Config.WSS_BASE + "/ws";

let client: W3CWebSocket;


class WebsocketClient {
    t: Ticks | undefined;

}


export function init() {
    if(!!client && client.readyState===client.OPEN){
        return
    }
    client = new W3CWebSocket(base);
    console.log("connecting websocket")
    client.onmessage = (message => {
        let json = JSON.parse(message.data.toString());
        if (json.all && wc.t) {
            wc.t.all(json.all);
        }
        if (json.myMarket && wc.t) {
            wc.t.onSGBFeed(json.myMarket);
        }
        if (json.equityMarket && wc.t) {
            wc.t.onEquityFeed(json.equityMarket);
        }
        if (json.myOptions && wc.t) {
            wc.t.onOptionsFeed(json.myOptions);
        }
        if (json.options2 && wc.t) {
            wc.t.onTickFeed(json.options2[0])
        }
        if (json.congo && wc.t) {
            wc.t.congratulations();
        }
        if (json.hurry && wc.t) {
            wc.t.hurry();
        }
    })
}

export function close(){
    if(!!client && client.readyState===client.CLOSED){
        return
    }
    console.log("closed websocket")
    client.close()
}
let wc = new WebsocketClient();
// onReady(init)
init();

export default wc;